import { render } from "./ProductSelectionBrandsFilters.vue?vue&type=template&id=c6f5de5c&scoped=true&ts=true"
import script from "./ProductSelectionBrandsFilters.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionBrandsFilters.vue?vue&type=script&lang=ts"

import "./ProductSelectionBrandsFilters.vue?vue&type=style&index=0&id=c6f5de5c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f5de5c"]])

export default __exports__